import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ServicesOverview from "./sections/ServicesOverview";
import WhyChooseUs from "./sections/WhyChooseUs";
import StormDamageInsuranceAssistance from "./sections/StormDamageInsuranceAssistance";
import ServiceAreas from "./sections/ServiceAreas";
import Testimonials from "./sections/Testimonials";
import FinalCtaSection from "./sections/FinalCtaSection";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <HeroSection />
      <ServicesOverview />
      <WhyChooseUs />
      <StormDamageInsuranceAssistance />
      <ServiceAreas />
      <Testimonials />
      <FinalCtaSection />
      <Footer />
    </div>;
}